import { AppForm } from '../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { CustomValidator } from '../../../../../../common/forms/custom.validators';
import { UserDetails } from '../../../../../../store/reducers/user-details.reducer';
import { TokenData } from '../../../../../../services/ssession.service';
import { ApplicationAppEntityApplicationRead, ApplicationAppEntityApplicationWrite } from '../../../../../../openapi';

export class ProxyPersonForm extends AppForm {

  constructor() {
    super({
      firstName: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      lastName: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      phone: new FormControl('', {
        validators: [Validators.required, CustomValidator.phone(), Validators.maxLength(255)],
        nonNullable: true
      }),
      email: new FormControl('', {
        validators: [
          Validators.required,
          CustomValidator.email(),
          Validators.maxLength(255)
        ],
        nonNullable: true
      }),
      zipCode: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      postOffice: new FormControl('', {
        validators: [Validators.maxLength(255)],
        nonNullable: true
      }),
      city: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      street: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      buildingNumber: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      apartmentNumber: new FormControl('', Validators.maxLength(255))
    });
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      proxyFirstName: this.value?.firstName,
      proxyLastName: this.value?.lastName,
      proxyCity: this.value?.city,
      proxyEmail: this.value?.email,
      proxyPhone: this.value?.phone,
      proxyStreet: this.value?.street,
      proxyApartmentNumber: this.value?.apartmentNumber,
      proxyHouseNumber: this.value?.buildingNumber,
      proxyPostalCode: this.value?.zipCode,
      proxyPostOffice: this.value?.postOffice || ''
    };
  }

  public override patchFormValues(app: ApplicationAppEntityApplicationRead | null) {
    this.patchValue({
      firstName: app?.proxyFirstName,
      lastName: app?.proxyLastName,
      city: app?.proxyCity,
      email: app?.proxyEmail,
      phone: app?.proxyPhone,
      street: app?.proxyStreet,
      apartmentNumber: app?.proxyApartmentNumber,
      buildingNumber: app?.proxyHouseNumber,
      zipCode: app?.proxyPostalCode,
      postOffice: app?.proxyPostOffice || '',
      isFiledByProxy: !!app?.isFiledByProxy
    });
  }

  public readApplicantDataFromPortal(v: UserDetails | null): void {
    this.patchValue({
      firstName: v?.firstName || '',
      lastName: v?.lastName || '',
      email: v?.email || '',
      phone: v?.phoneNumber || '',
      city: v?.city,
      buildingNumber: v?.houseNumber,
      apartmentNumber: v?.apartmentNumber || '',
      zipCode: v?.postalCode || '',
      postOffice: v?.postOffice || '',
      street: v?.street
    });
  }

  public readApplicantDataFromGovPl(v: TokenData | null): void {
    this.patchValue({
      firstName: v?.firstName || '',
      lastName: v?.lastName || '',
      email: v?.email || '',
      city: '',
      buildingNumber: '',
      apartmentNumber: '',
      zipCode: '',
      postOffice: '',
      street: ''
    });
  }
}
